<template>
  <div :class="$modal.modalContentContainer">
    <div :class="$modal.modalContent">
      <v-flex>
        <p :class="$modal.modalText">
          Enter in your new password
        </p>
      </v-flex>
      <v-flex :class="[$modal.modalInput, $modal.shortInput]">
        <InputField :class="{[$modal.errorField] : $v.password.$error }"
                    v-model="$v.password.$model"
                    :type="show ? 'text' : 'password'"
                    label="Password*"/>
        <button :class="$modal.passVisibility"
                @click.prevent="show = !show">
          {{ showPassMessage() }}
        </button>
        <p v-if="$v.password.$error"
           :class="$modal.errorMessage">Incorrect PIN - Please try again</p>
        <p v-if="errors"
           :class="$modal.errorMessage">
          {{ errors }}
        </p>
      </v-flex>
      <v-flex :class="$modal.modalButtons">
        <BaseButton :button-style="'Main'"
                    :class="$modal.submitBtn"
                    @click="formAction">Submit</BaseButton>
        <button :class="$modal.cancelBtn"
                @click="close()">Cancel</button>
      </v-flex>
    </div>

    <CommonModal :display="isPasswordChangedAlertVisible"
                 :width="280"
                 :always-modal="true"
                 title="Password Changed"
                 type="SmallModal"
                 name="linkSent"
                 @toggleModal="setPasswordChangedAlert(arguments[1])">
      <PasswordChanged @close="setPasswordChangedAlert(false)"/>
    </CommonModal>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import { Action } from 'vuex-class';
import { AUTH_RESET_PASSWORD } from '@/apps/auth/store/types';
import authMixins from '@/apps/auth/mixins';
import Logo from '@/components/Logo';
import BaseButton from '@/components/BaseButton';
import InputField from '@/components/InputField';
import PasswordChanged from '@/apps/auth/components/PasswordChanged';
import CommonModal from '@/apps/shared/components/CommonModal';

  /**
   * Form to check if phone number exists. On success will store pone data in
   * vuex store for further use.
   */
  @Component({
    name:       'PasswordReset',
    components: {
      Logo,
      BaseButton,
      InputField,
      PasswordChanged,
      CommonModal,
    },
    validations: {
      password: { required },
    },
    mixins: [
      authMixins.AuthorizationMixin,
    ],
  })
export default class PasswordReset extends Vue {
    isPasswordChangedAlertVisible = false;
    password = '';
    show = false;

    @Action(AUTH_RESET_PASSWORD) vuexAction;

    getData() {
      return {
        password: this.password,
        token:    this.$route.params.token,
        uid:      this.$route.params.uid,
      };
    }

    /**
     * Emits close event on successful action finish. Close event should be
     * handled on the parent component to close modal.
     * @param data
     */
    handleSuccess(data) {
      this.responseData = data;
      this.isPasswordChangedAlertVisible = true;
    }

    setPasswordChangedAlert(value) {
      this.isPasswordChangedAlertVisible = value;
      if (!value) {
        this.$emit('close');
      }
    }

    showPassMessage() {
      if (this.show) {
        return 'Hide';
      }

      return 'Show';
    }
  }
</script>

<style src="@/style/modals.scss" lang="scss" module="$modal"></style>




// WEBPACK FOOTER //
// src/apps/auth/components/PasswordReset.vue